module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M30 0H2a2 2 0 0 0-2 2v28a2 2 0 0 0 2 2h28a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zM10.886 26H6v-4.886L18.218 8.896l4.886 4.886L10.886 26zM27.314 9.57l-1.766 1.766-4.886-4.886 1.766-1.766a2.444 2.444 0 0 1 3.456 0l1.432 1.434c.954.952.954 2.5-.002 3.452z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/compose-2.js
// module id = 1085
// module chunks = 14